<div class="row">
  <div class="col-md-6">
    <header class="bg-purple fixed-top header-customizations">
      <div class="container-fluid">
        <div class="row">
          <div class="col">
            <nav class="navbar navbar-expand-lg navbar-light">
              <button
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
                class="navbar-toggler p-0"
                data-bs-target="#navbarSupportedContent"
                data-bs-toggle="collapse"
                type="button"
              >
                <span class="navbar-toggler-icon"></span>
              </button>
              <a
                class="navbar-brand"
                id="brandName"
                routerLink="/idp-configurations"
              >
                Identity Federation
              </a>

              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto"></ul>

                <ul class="navbar-nav navbar-right">
                  <li class="nav-item">
                    <a
                      data-cy="help-menu-image"
                      class="nav-link"
                      [href]="helpUrl"
                      target="_blank"
                      rel="noopener"
                    >
                      <i
                        class="png-icon-sm png-help nav-item-icon"
                        aria-hidden="true"
                      ></i>
                      <span class="nav-item-title">Help</span>
                    </a>
                  </li>
                  <li
                    *ngIf="(user$ | async)?.email"
                    class="nav-item dropdown"
                    png-user-account
                    [displaySignIn]="false"
                    [displaySignOut]="true"
                    (signOut)="onSignOut()"
                    [user]="(user$ | async) ?? {}"
                  ></li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
  </div>
</div>
